import type { CategoryColor } from "../../utils/eventDisplay";

const SOLID_BG: Record<CategoryColor, string> = {
    pink: "#fce4ef",
    green: "#e8f8ee",
    orange: "#fef3e8",
    purple: "#ede9fe",
    blue: "#dbeafe",
};

type Props = {
    color: CategoryColor;
    className?: string;
    label?: string;
    emoji?: string;
    emojiClassName?: string;
};

export function EventPhotoPlaceholder({
    color,
    className = "",
    label = "EVENT PHOTO",
    emoji,
    emojiClassName,
}: Props) {
    return (
        <div
            className={`flex items-center justify-center overflow-hidden rounded-2xl ${className}`}
            style={{ background: SOLID_BG[color] }}
            aria-hidden
        >
            {emoji ? (
                <span className={emojiClassName ?? "text-3xl sm:text-4xl"}>
                    {emoji}
                </span>
            ) : (
                <span className="text-[0.6rem] font-semibold tracking-widest text-foreground/30 sm:text-xs">
                    {label}
                </span>
            )}
        </div>
    );
}
